import React from 'react';
import LegalDocument from '../components/LegalDocument';
import legalContent from '../legal/legalContent.json';

// The words come from the app's canonical source; this page only renders
// them. See src/components/LegalDocument.js.
const PrivacyPolicyPage = () => (
  <LegalDocument document={legalContent.privacyPolicy} lastUpdated={legalContent.lastUpdated} />
);

export default PrivacyPolicyPage;
